import React, { useEffect, useRef, useState } from 'react';
import './GoogleMapComponent.scss';
import { windowWidth, getBasLabels } from '../../utils/commonUtils';
import Modal from '../Modal/Modal';
import MobileViewShowDealer from '../ModalContentTypes/MobileViewShowDealer/MobileViewShowDealer';
import { useAppUiStore } from '../../hooks/useStores';
// let isDefaultLoad = false;

const GoogleMapComponent = ({
  markerLocations,
  selectedDealer,
  setShowDistributorModal,
  resetSelectedDealerMob,
  showDealerModalMobParent,
}) => {
  const labels = getBasLabels();
  const mapRef = useRef(null); // Ref to hold the map container
  const markersRef = useRef([]); // Ref to hold marker instances
  const infoWindowRef = useRef(null); // Ref to hold the InfoWindow instance
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [dealerForMob, setDealerForMob] = useState(null);
  const [showDealerModalMob, setShowDealerModalMob] = useState(false);
  const { uiStore } = useAppUiStore();
  const [markersState, setMarkersState] = useState(false);

  useEffect(() => {
    setShowDealerModalMob(showDealerModalMobParent);
  }, [showDealerModalMobParent]);

  // useEffect(() => {
  //   isDefaultLoad = false;
  // }, []);

  useEffect(() => {
    // Initialize the map once the script is loaded
    const map = new window.google.maps.Map(mapRef.current, {
      zoom: 12,
      styles: [
        {
          stylers: [{ hue: '#00bbee' }, { saturation: -70 }],
        },
      ],
    });

    // Initialize InfoWindow
    const infoWindow = new window.google.maps.InfoWindow();
    infoWindowRef.current = infoWindow;
    let dealershipCount = 0;

    markerLocations.forEach((location, i) => {
      if (i === 0) {
        map.setCenter({ lat: parseFloat(location.Latitude), lng: parseFloat(location.Longitude) }); // Set map center to first marker location
      }
      let marker = null;
      if (location?.HasServiceAddress === '1') {
        ++dealershipCount;
        marker = new window.google.maps.Marker({
          position: { lat: parseFloat(location.Latitude), lng: parseFloat(location.Longitude) },
          map: map,
          animation: window.google.maps.Animation.DROP,
          title: location.Name, // Tooltip on hover
          icon: {
            url: '/assets/feature/genesis/buildandorder/assets/images/location-pin.svg', // Custom marker icon
            scaledSize: new window.google.maps.Size(50, 50), // Icon size
            labelOrigin: new window.google.maps.Point(25, 12), // Adjust label position (x, y)
          },
          label: {
            text: String(dealershipCount),
            color: 'black',
            fontSize: '10px',
            fontWeight: 'bold',
          },
        });
      }

      // Add marker to markersRef for external control
      markersRef.current[i] = marker;

      // Attach click event to open InfoWindow
      marker?.addListener('click', () => {
        const contentDiv = document.createElement('div');
        contentDiv.className = 'infowindow_container';
        let winWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if (winWidth < 768) {
          setDealerForMob(location);
          setShowDealerModalMob(true);
          document.querySelector('.modal_content.carbon').style.overflow = 'hidden';
        } else {
          contentDiv.innerHTML = `<div class="infowindow_container">
            <div class="dealer_name_img">
                <span class="dealer_name">${location.Name}</span>
                <img class="dealer_img" src=${location.DistributorImagePath}>
            </div>
            <div class="dealer_info_container">
                <div class="address_phone_mail">
                    <div class="address_details">
                        <div class="icon_label">
                            <span class="icon-GENS_pin"></span>
                            <span class="label">${labels.addressTitle}</span>
                        </div>
                        <div class="address">${location.ServiceAddressStreet}</div>
                        <div class="address">${location.ServiceAddressPostalCode}</div>
                        <div class="get_directions_container">
                          <a class="get-direction-link"
                              href=${`https://www.google.com/maps?q=${location.Latitude},${location.Longitude}`}
                              target="_blank"
                              rel="noopener noreferrer">
                            ${labels?.getDirections}
                          </a>
                        </div>
                    </div>
                    <div class="call_details">
                        <span class="icon-GENS_phone"></span>
                        <span class="phone">${location.Phone}</span>
                    </div>
                    <div class="mail_details">
                    <span class="icon-GENS_email"></span>
                        <span class="email">${location.ServiceEmail}</span></div>
                </div>
                <div class="service_hours_container">
                    <div class="service_icon_label">
                        <span class="icon-GENS_store"></span>
                        <span class="service_label">${labels.serviceHoursTitle}</span>
                    </div>
                    <div class="service_hours_container">
                    ${generateServiceHoursHtml(location)}
                    </div>
                </div>
            </div>
        </div>`;
          infoWindow.setContent(contentDiv);
          infoWindow.open(map, marker);
        }
      });
    });
    setMarkersState(true);
  }, [markerLocations, isMobileView]);

  useEffect(() => {
    const marker = markersRef.current[selectedDealer];
    const infoWindow = infoWindowRef.current;

    if (marker && infoWindow) {
      const contentDiv = document.createElement('div');
      contentDiv.className = 'infowindow_container';
      let winWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      if (winWidth < 768) {
        // if (isDefaultLoad) {
        // Update map view by panning to the selected marker
        marker.getMap().panTo(marker.getPosition());
        marker.getMap().setZoom(14); // Optionally adjust the zoom level
        setDealerForMob(markerLocations[selectedDealer]);
        setShowDealerModalMob(true);
        document.querySelector('.modal_content.carbon').style.overflow = 'hidden';
        // } else {
        //   isDefaultLoad = true;
        // }
      } else {
        contentDiv.innerHTML = `<div class="infowindow_container">
        <div class="dealer_name_img">
            <span class="dealer_name">${markerLocations[selectedDealer].Name}</span>
            <img class="dealer_img" src=${markerLocations[selectedDealer].DistributorImagePath}>
        </div>
        <div class="dealer_info_container">
            <div class="address_phone_mail">
                <div class="address_details">
                    <div class="icon_label">
                        <span class="icon-GENS_pin"></span>
                        <span class="label">${labels.addressTitle}</span>
                    </div>
                    <div class="address">${markerLocations[selectedDealer].ServiceAddressStreet}</div>
                    <div class="address">${markerLocations[selectedDealer].ServiceAddressPostalCode}</div>
                    <div class="get_directions_container">
                      <a class="get-direction-link"
                          href=${`https://www.google.com/maps?q=${markerLocations[selectedDealer].Latitude},${markerLocations[selectedDealer].Longitude}`}
                          target="_blank"
                          rel="noopener noreferrer">
                        ${labels?.getDirections}
                      </a>
                    </div>
                </div>
                <div class="call_details">
                    <span class="icon-GENS_phone"></span>
                    <span class="phone">${markerLocations[selectedDealer].Phone}</span>
                </div>
                <div class="mail_details">
                <span class="icon-GENS_email"></span>
                    <span class="email">${markerLocations[selectedDealer].ServiceEmail}</span>
                    </div>
            </div>
            <div class="service_hours_container">
                <div class="service_icon_label">
                    <span class="icon-GENS_store"></span>
                    <span class="service_label">${labels.serviceHoursTitle}</span>
                </div>
                <div class="service_hours_container">
                ${generateServiceHoursHtml(markerLocations[selectedDealer])}
                </div>
            </div>
        </div>
    </div>`;
        // Set content and open InfoWindow
        infoWindow.setContent(contentDiv);
        infoWindow.open(marker.getMap(), marker);
      }
    }
  }, [selectedDealer, markersState]);

  function dealerSelected(dealer) {
    console.log(dealer);
    uiStore.updateDealerSelectionBAS(dealer);
    setShowDealerModalMob(false);
    setShowDistributorModal(false);
  }

  function generateServiceHoursHtml(loc) {
    let html = '';
    loc.Hours.Service.Days.forEach((serviceHour) => {
      html += `<div class="day_item">
                    <span class="weekday">${serviceHour.Weekday.substring(0, 3)}</span>
                    <span class="hours">${serviceHour.Start} - ${serviceHour.End}</span>
                </div>`;
    });
    return html;
  }

  function closeMobView() {
    setDealerForMob(null);
    resetSelectedDealerMob(-1);
    document.querySelector('.modal_content.carbon').style.overflow = 'auto';
  }

  return (
    <>
      <div ref={mapRef} className="map_container"></div>
      {isMobileView && dealerForMob && (
        <MobileViewShowDealer
          dealer={dealerForMob}
          generateServiceHoursHtml={generateServiceHoursHtml}
          dealerSelected={dealerSelected}
          closeMobView={closeMobView}
        />
      )}
    </>
  );
};

export default GoogleMapComponent;
